import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-calendar-filter', {
  mixins: [eventListenerMixin],

  connected() {
    this.assigneeGuid = '';
    this.labelId = '';

    this.link = this.querySelector('.js-show-popover');
    this.listenTo(this.link, 'click', () => {
      const popover = this.renderPopover();

      popover.el.find('#select-assignee').on('tao:change', (e) => {
        this.assigneeGuid = e.detail;
        if (e.detail) {
          $('.todo').hide();
          $(`.todo[data-assignee-guid="${e.detail}"]`).show();
        } else {
          $('.todo').show();
        }
      });

      popover.el.find('#select-label').on('tao:change', (e) => {
        this.labelId = e.detail;

        if (!e.detail) {
          $('.todo').show();
          return;
        }

        $('.todo').hide();
        $('.todo[data-label-ids]').each((index, element) => {
          const ids = element.dataset.labelIds.split(',');
          if (ids.indexOf(e.detail.toString()) > -1) $(element).show();
        });
      });
    });
  },

  renderPopover() {
    const content = $(this.querySelector('#tpl-calendar-filter-popover').innerHTML);

    if (this.assigneeGuid) {
      content.find(`#select-assignee option[value="${this.assigneeGuid}"]`).prop('selected', true);
    }

    if (this.labelId) {
      content.find(`#select-label option[value="${this.labelId}"]`).prop('selected', true);
    }

    const popover = window.simple.popover({
      cls: 'tr-calendar-filter-popover',
      pointTo: $(this.link),
      content,
      position: 'bottom-left',
    });
    return popover;
  },

  disconnected() {
    this.stopListening();
  },
});
